/**
 * Desktop (lg+) guest navigation: the shared Sidebar with the pre-login tabs.
 * Same handlers as the mobile menu — public tabs navigate and track
 * `unauth.tab_view`; locked tabs track `unauth.locked_tab_click` and pop the
 * signup modal. The "Create an account" banner stays above the page content.
 */

import { useLocation } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { Sidebar, type SidebarItem } from '@/shared/components/Sidebar';
import { useGuestSignupModal } from '../context/GuestSignupModalContext';
import { useUnauthRumAction } from '../hooks/useUnauthRumAction';
import { LOCKED_TAB_HINT, TABS } from './preLoginTabs';

export const PreLoginSidebar = () => {
  const { pathname } = useLocation();
  const { openModal } = useGuestSignupModal();
  const trackAction = useUnauthRumAction();

  const items: SidebarItem[] = TABS.map((tab) =>
    'locked' in tab
      ? {
          key: tab.label,
          label: tab.label,
          icon: tab.icon,
          locked: true,
          hint: LOCKED_TAB_HINT,
          onClick: () => {
            trackAction('unauth.locked_tab_click', { tab: tab.label });
            openModal({ trigger: 'locked_tab_click', triggerEntityId: tab.label });
          },
        }
      : {
          key: tab.label,
          label: tab.label,
          icon: tab.icon,
          href: tab.href,
          active: pathname === tab.href,
          onClick: () => trackAction('unauth.tab_view', { tab: tab.label }),
        }
  );

  return (
    <Sidebar
      homeHref="/"
      items={items}
      footerItems={[{ key: 'login', label: 'Login', icon: LogIn, href: '/login' }]}
    />
  );
};
